import { Button, CircularProgress, IconButton, Stack } from "@mui/material"
import { approveEscalate, generateInvoice } from "../../api"
import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import PrintIcon from "@mui/icons-material/Print"
import { useSnackbar } from "notistack"
import { useState } from "react"
import dayjs from "dayjs"
import html2pdf from 'html2pdf.js'
import jsPDF from "jspdf"

export const downloadInvoice = (file) => {
  const doc = new jsPDF()
  fetch(file)
    .then(response => response.text())
    .then(html => {
      html2pdf().from(html).set({
        margin: [10, 10],
        filename: 'invoice.pdf',
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'portrait', format: 'a4' }
      }).save();
    });
}

const IncomeCard = ({ data, refresh, approve, reset }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const onAction = (type, action, id) => {
    setLoading(true)
    approveEscalate(type, action, id)
      .then(() => {
        enqueueSnackbar("Income Status updated!", { variant: "success" })
        reset()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <CardContainer
      disableEditDelete
      SummaryContent={
        <>
          <CardStat label="Income Head" value={data?.incomeHead_?.name} />
          <CardStat label="Particulars" value={data?.particulars} />
          <CardStat label="Depositor" value={data?.depositor?.name} />
          <CardStat
            label="Amount"
            value={`₹${parseFloat(data?.amount || 0).toFixed(2)}`}
          />
        </>
      }
      DetailsContent={
        <>
          <CardStat label="Mode" value={data?.modeOfPayment} />
          <CardStat label="Receipt Number" value={data?.receiptNumber} />
          <CardStat label="Status" value={data?.status} />
          <CardStat
            label="Created"
            value={dayjs(data?.creationTimestamp).format(
              "MMM DD, YYYY | HH:mm A"
            )}
          />
        </>
      }
      ActionButtons={
        approve ? (
          <Stack spacing={1}>
            <Button onClick={() => onAction("income", "escalate", data.id)}>
              {loading ? <CircularProgress /> : "Escalate"}
            </Button>
            <Button
              onClick={() => onAction("income", "approve", data.id)}
              variant="contained"
            >
              {loading ? <CircularProgress /> : "Approve"}
            </Button>
          </Stack>
        ) : data.invoice ? (
          <IconButton onClick={() => downloadInvoice(data?.invoice)}>
            <ReceiptLongIcon color="primary" title="Download Invoice" />
          </IconButton>
        ) : (
          <IconButton
            onClick={() =>
              generateInvoice(data.id)
                .then(() => {
                  enqueueSnackbar("Invoice Generated", {
                    variant: "success",
                  })
                  refresh()
                })
                .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
            }
            variant="contained"
          >
            <PrintIcon color="secondary" title="Generate Invoice" />
          </IconButton>
        )
      }
    />
  )
}

export default IncomeCard
